module.exports = __webpack_public_path__ + "static/media/Investment.7a3c6bac.svg";